import { useGlobalContainerRef } from '@/wc/helper/ref';
import { Tooltip } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import React from 'react';
import styles from './TooltipCell.module.scss';

const cx = classnames.bind(styles);

export type TooltipCellProps = {
  title: React.ReactNode;
  className?: string;
  wrapperClassName?: string;
  children: React.ReactNode;
};

export const TooltipCell: React.FC<TooltipCellProps> = ({
  title,
  className,
  children,
  wrapperClassName,
}) => {
  const container = useGlobalContainerRef();

  return (
    <Tooltip
      title={title}
      overlayClassName={cx(styles['tooltipContainer'], wrapperClassName)}
      getPopupContainer={container}
      destroyTooltipOnHide
    >
      <div className={cx(styles['tooltipCellWrapper'], 'tooltip-cell-wrapper')}>
        <div className={cx(styles['ellipsisText'], className)}>{children}</div>
      </div>
    </Tooltip>
  );
};
